import axios from "axios";

const DEV_API_ORIGIN = "https://localhost:7234";
const DEFAULT_PROD_API_ORIGIN = "https://www.oberin.be";

const ALLOWED_PROD_ORIGINS = new Set([
    "https://www.oberin.be",
    "https://oberin.be",
    "https://www.oberin.com",
    "https://oberin.com",
]);

function normalizeOrigin(origin) {
    return (origin || "").trim().toLowerCase().replace(/\/+$/, "");
}

function getCurrentOrigin() {
    if (typeof window === "undefined" || !window.location) {
        return "";
    }

    return window.location.origin;
}

function resolveBaseApiOrigin() {
    if (process.env.NODE_ENV === "development") {
        return DEV_API_ORIGIN;
    }

    const currentOrigin = normalizeOrigin(getCurrentOrigin());

    if (ALLOWED_PROD_ORIGINS.has(currentOrigin)) {
        return currentOrigin;
    }

    return DEFAULT_PROD_API_ORIGIN;
}

export const baseApiUrl = `${resolveBaseApiOrigin()}/`;

let url = baseApiUrl + "api/";

const instance = axios.create({
    baseURL: url,
    headers: {},
});

instance.interceptors.request.use(
    (config) => {
        let bearerToken = sessionStorage.getItem("OBERIN_BEARER_TOKEN");
        if (bearerToken) {
            config.headers = {
                ...config.headers,
                Authorization: "Bearer " + bearerToken,
            };
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

export default instance;
